import React from "react";
import worldMap from "../images/exportcountriesmap.png";

const ExportCountries = () => {
  const countries = [
    {
      name: "UAE",
      img: "https://flagcdn.com/w40/ae.png",
      top: "55%",
      left: "60%",
      color: "#22c55e",
    },
    {
      name: "USA",
      img: "https://flagcdn.com/w40/us.png",
      top: "45%",
      left: "20%",
      color: "#3b82f6",
    },
    {
      name: "UK",
      img: "https://flagcdn.com/w40/gb.png",
      top: "35%",
      left: "48%",
      color: "#ef4444",
    },
    {
      name: "Saudi Arabia",
      img: "https://flagcdn.com/w40/sa.png",
      top: "58%",
      left: "57%",
      color: "#f59e0b",
    },
    {
      name: "Singapore",
      img: "https://flagcdn.com/w40/sg.png",
      top: "68%",
      left: "72%",
      color: "#ec4899",
    },
    {
      name: "Canada",
      img: "https://flagcdn.com/w40/ca.png",
      top: "30%",
      left: "22%",
      color: "#8b5cf6",
    },
    {
      name: "Australia",
      img: "https://flagcdn.com/w40/au.png",
      top: "80%",
      left: "78%",
      color: "#14b8a6",
    },
    {
      name: "India",
      img: "https://flagcdn.com/w40/in.png",
      top: "55%",
      left: "67%",
      color: "#f97316",
    },
  ];

  return (
    <div className="container">
      <div className="overlay">
        <h2 className="title">Countries We Export To 🌿</h2>

        <div className="content">
          {/* LEFT LIST */}
          <div className="country-list">
            {countries.map((country, index) => (
              <div className="country-item">
                <img
                  src={country.img}
                  alt={country.name}
                  className="flag-img"
                />
                <span>{country.name}</span>
              </div>
            ))}
          </div>

          {/* RIGHT MAP */}
          <div className="map-section">
            <div className="map-wrapper">
              <img src={worldMap} alt="World Map" className="map-image" />

              {countries.map((c, i) => (
                <div
                  key={i}
                  className="pin"
                  style={{ top: c.top, left: c.left }}
                >
                  <span className="pin-icon" style={{ color: c.color }}>
                    📍
                  </span>

                  <span className="tooltip">
                    <img src={c.img} alt="" /> {c.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
/* ===== CONTAINER ===== */
.container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.overlay {
  width: 100%;
  max-width: 1300px;
  padding: 50px 40px;
  background:#f8f6f2;
}

/* ===== TITLE ===== */
.title {
  font-family: 'Poppins', sans-serif;
  font-size: clamp(26px, 4vw, 30px);
  font-weight: 800;
  letter-spacing: 0.6px;
  margin-bottom: 20px;

  /* Premium gradient text */
  background: linear-gradient(90deg, #111111, #111111, #111111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  /* subtle glow */
  text-shadow: 0 6px 2px rgba(158, 155, 155, 0.3);

  position: relative;
  display: inline-block;
  animation: fadeUp 0.8s ease;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== LAYOUT ===== */
.content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

/* ===== LIST ===== */
.country-list {
  flex: 1;
  min-width: 250px;
}

.country-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 18px;
}

.flag {
  margin-right: 10px;
  font-size: 22px;

  font-family: "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif;
}
  .flag-img {
  width: 28px;
  height: 18px;
  margin-right: 10px;
  border-radius: 3px;
}

.tooltip img {
  width: 20px;
  height: 14px;
  margin-right: 5px;
  vertical-align: middle;
}

/* ===== MAP ===== */
.map-section {
  flex: 2;
  min-width: 300px;
  display: flex;
  justify-content: center;
}

.map-wrapper {
  position: relative;
  width: 100%;
  max-width: 700px;
}

.map-image {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== PIN ===== */
.pin {
  position: absolute;
  transform: translate(-50%, -100%);
  cursor: pointer;
}

.pin-icon {
  font-size: 22px;
  transition: transform 0.2s;
}

.pin:hover .pin-icon {
  transform: scale(1.2);
}

/* ===== TOOLTIP ===== */
.tooltip {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  background: black;
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 5px;
  white-space: nowrap;
  opacity: 0;
  transition: 0.3s;
}

.pin:hover .tooltip {
  opacity: 1;
}

/* ===== TABLET ===== */
@media (max-width: 1024px) {
  .title {
    font-size: 26px;
  }

  .overlay {
    padding: 40px 25px;
  }

  .map-wrapper {
    max-width: 500px;
  }
}

/* ===== MOBILE ===== */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
    align-items: center;
  }

  .country-list {
    width: 100%;
  }

  .country-item {
  display: grid;
  grid-template-columns: 40px 1fr;
  align-items: center;
  justify-content: center;
  text-align: left;
  gap: 10px;
}
  /* FLAG FIX */
.flag-img {
  width: 28px;
  height: 18px;
  object-fit: cover;
}

/* TEXT FIX */
.country-item span {
  font-size: 16px;
}

  .map-wrapper {
    max-width: 300px;
  }

  .pin-icon {
    font-size: 16px;
  }

  .tooltip {
    font-size: 10px;
  }
}

/* ===== SMALL MOBILE ===== */
@media (max-width: 480px) {
  .title {
    font-size: 20px;
  }

  .map-wrapper {
    max-width: 250px;
  }
}
      `}</style>
    </div>
  );
};

export default ExportCountries;
